export default __webpack_public_path__ + "static/media/Hallticket2.43e8c518.jpg";